import copy from 'clipboard-copy'
import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Snackbar from '@material-ui/core/Snackbar'
import { withStyles } from '@material-ui/core/styles'

// old: 35LFNRqYcJsw5ewGVib4pvfuQEBAyFLXwy
// old: 32cLedSbWaaFu6Aw61Pz35vKv9mTrh6sMU
const btcAddress = 'bc1q388znz2hafr8rwzjd6rvj70m9ccp3n98sw3y2u' // blue (same as privkeyfixer)

const styles = theme => ({
  button: {
    textTransform: 'none'
  }
})

class BitcoinDonationAddress extends React.Component {
  state = {
    open: false,
    vertical: 'top',
    horizontal: 'center',
  }

  handleClick = state => () => {

    if (copy(btcAddress)) {
      this.setState({ open: true })
    }
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { classes } = this.props
    const { vertical, horizontal, open } = this.state

    return (
      <span>
        <Button className={classes.button} variant="contained" onClick={this.handleClick({ vertical: 'top', horizontal: 'center' })}>
          {btcAddress}
        </Button>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">Address copied</span>}
        />
      </span>
    )
  }
}

BitcoinDonationAddress.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(BitcoinDonationAddress)



// WEBPACK FOOTER //
// ./src/BitcoinDonationAddress.js